export default __webpack_public_path__ + "static/media/logo.213f81c4.svg";